<template>
  <div class="crear-cultivo-container">
    <h2 class="mb-4">Crear Nuevo Cultivo</h2>
    <form @submit.prevent="crearProyecto" class="p-4 shadow-sm rounded bg-light">
      <!-- Campo Nombre -->
      <div class="mb-3">
        <label for="nombre" class="form-label">Nombre del Cultivo:</label>
        <div class="input-group">
          <input v-model="nombre" type="text" class="form-control" id="nombre"
            placeholder="Ingresa el nombre del cultivo" required />
          <button type="button" class="btn btn-secondary" @click="generarNombre">
            Sugerir Nombre
          </button>
        </div>
      </div>

      <!-- Campos de Fecha -->
      <div class="row mb-3">
        <div class="col-md-6">
          <label for="fecha_inicio" class="form-label">Fecha de Inicio:</label>
          <input v-model="fecha_inicio" type="date" class="form-control" id="fecha_inicio" @change="calcularDias"
            required />
        </div>
        <div class="col-md-6">
          <label for="fecha_fin" class="form-label">Fecha de Fin:</label>
          <input v-model="fecha_fin" type="date" class="form-control" id="fecha_fin" :min="fecha_inicio"
            @change="calcularDias" />
        </div>
      </div>

      <!-- Campo Cantidad de Días -->
      <div class="row mb-3">
        <div class="col-md-6">
          <label for="dias" class="form-label">Cantidad de Días:</label>
          <div class="input-group">
            <input v-model.number="cantidad_dias" type="number" class="form-control" id="dias"
              placeholder="Ingresa días" @input="calcularFechaFin" min="1" />
            <span class="input-group-text">días</span>
          </div>
        </div>
        <div class="col-md-6">
          <p class="mt-4">Duración: <strong>{{ cantidad_dias }}</strong> días</p>
        </div>
      </div>

      <!-- Campo Descripción -->
      <div class="mb-3">
        <label for="descripcion" class="form-label">Descripción del Cultivo:</label>
        <textarea v-model="descripcion" class="form-control" id="descripcion" rows="3"
          placeholder="Ingresa una descripción detallada" required></textarea>
      </div>

      <!-- Botón de Envío -->
      <div class="d-flex justify-content-end">
        <button type="submit" class="btn btn-success">Crear Cultivo</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  data() {
    return {
      nombre: "",
      fecha_inicio: this.obtenerFechaActual(), // Fecha actual por defecto
      fecha_fin: "",
      descripcion: "",
      cantidad_dias: 0,
      club_id: this.$store.getters.getClubActual?.id || null, // Obtiene el club_id del store
    };
  },
  methods: {
    async crearProyecto() {
      try {
        if (!this.club_id) {
          alert("No se puede crear el cultivo porque no tienes un club asociado.");
          return;
        }

        const unProyecto = {
          nombre: this.nombre,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          descripcion: this.descripcion,
          club_id: this.club_id,
        };

        const proyectoCreado = await axios.post(`/api/clubes/${this.club_id}/proyectos`, unProyecto);
        this.$store.commit("setProyectoActual", proyectoCreado.data);
        alert("Proyecto creado con éxito");

        this.$emit("proyectoCreado", proyectoCreado.data); // ✅ navegación interna
      } catch (error) {
        console.error("Error al crear proyecto:", error);
        alert(error.response.data);
      }
    },
    obtenerFechaActual() {
      const hoy = new Date();
      return hoy.toISOString().split("T")[0]; // Retorna la fecha en formato 'YYYY-MM-DD'
    },
    calcularDias() {
      if (this.fecha_inicio && this.fecha_fin) {
        const inicio = new Date(this.fecha_inicio);
        const fin = new Date(this.fecha_fin);
        this.cantidad_dias = Math.max(
          Math.ceil((fin - inicio) / (1000 * 60 * 60 * 24)),
          0
        );
      }
    },
    calcularFechaFin() {
      if (this.fecha_inicio && this.cantidad_dias > 0) {
        const inicio = new Date(this.fecha_inicio);
        const nuevaFechaFin = new Date(
          inicio.setDate(inicio.getDate() + this.cantidad_dias)
        );
        this.fecha_fin = nuevaFechaFin.toISOString().split("T")[0];
      }
    },
    generarNombre() {
      const prefijos = ["Cultivo", "Proyecto", "Plantación", "Iniciativa", "Producción", "Granja", "Huerto", "Cosecha", "Siembra", "Finca",
        "Agro", "BioCultivo", "EcoGranja", "VerdeOro", "Raíz",
        "Brotes", "Semillero", "Crecimiento", "VerdeVida", "Naturaleza",
        "Orgánico", "EcoHuerto", "Herencia", "Vital", "Renacer"];


      const sufijos = ["Norte", "Sur", "Este", "Oeste", "Verano", "Invierno", "Otoño", "Primavero", "Cumbre", "Horizonte", "Amanecer", "Atardecer",
        "Valle", "Sierras", "Pradera", "Oasis", "Refugio",
        "Jardín", "Llanura", "Cañada", "Alto", "Bajo",
        "Sector", "Zona", "Colina", "Fuente", "Brisa"
      ];

      const aleatorio = () => Math.floor(Math.random() * 1000).toString().padStart(3, "0");
      this.nombre = `${prefijos[Math.floor(Math.random() * prefijos.length)]} ${sufijos[Math.floor(Math.random() * sufijos.length)]
        } ${aleatorio()}`;
    },
  },
};
</script>

<style scoped>
.crear-cultivo-container {
  max-width: 600px;
  margin: auto;
  background: #f8f9fa;
}

h2 {
  color: #343a40;
}

.form-label {
  font-weight: bold;
}

.form-control {
  border: 1px solid #ced4da;
  border-radius: 5px;
}

.input-group button {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.btn-success {
  background-color: #28a745;
  border-color: #28a745;
}

.btn-success:hover {
  background-color: #218838;
  border-color: #1e7e34;
}

.shadow-sm {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.bg-light {
  background-color: #ffffff;
}
</style>
